import { useMemo, useState } from "react";

const isNull = v => v === null || v === undefined || v === "" || (typeof v === "number" && isNaN(v));

// Click cycle: number columns desc -> asc -> default order; text columns asc -> desc -> default order. Empty values stay last.
export function useSort(rows, cols) {
  const [s, setS] = useState({ c: -1, d: null });
  const sorted = useMemo(() => {
    if (s.c < 0) return rows;
    const { get, num } = cols[s.c], dir = s.d === "asc" ? 1 : -1;
    return [...rows].sort((a, b) => {
      const x = get(a), y = get(b), xn = isNull(x), yn = isNull(y);
      if (xn || yn) return xn - yn;
      return (num ? x - y : String(x).localeCompare(String(y))) * dir;
    });
  }, [rows, s, cols]);
  const cycle = i => setS(p => {
    const first = cols[i].num ? "desc" : "asc", second = cols[i].num ? "asc" : "desc";
    if (p.c !== i) return { c: i, d: first };
    return p.d === first ? { c: i, d: second } : { c: -1, d: null };
  });
  return { sorted, s, cycle };
}
